import { FC, useState } from 'react';

import { ImagesApp } from '../../../constants/images';
import { useEventContext } from '../../../hooks/contexts/event.context';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import * as Styles from './styles.errorAlert';

type ErrorAlertProps = {
  hideErrorMessage: () => void;
};

const ErrorAlert: FC<ErrorAlertProps> = ({ hideErrorMessage }) => {
  const [copied, setCopied] = useState(false);

  const { translate } = useI18nContext();
  const { event } = useEventContext();

  const handleCopy = () => {
    setCopied(true);
    navigator.clipboard.writeText(String(event!.attributes.urlRedirectFaceRecognition.value));

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <Styles.WrapperErrorAlert>
      <Styles.ContainerTitle>
        <Styles.Icon onClick={hideErrorMessage} src={ImagesApp.svg.errorX} alt="" />
        <Styles.Title>
          {translate(['INFORMATION', 'ASSIGN_USER_HASNT_REGISTER_FACE_WARNING'])}
        </Styles.Title>
      </Styles.ContainerTitle>
      <Styles.ContainerInfo>
        <Styles.InfoText>
          {translate(['INFORMATION', 'ASSIGN_USER_HASNT_REGISTER_FACE_WARNING_DESCRIPTION'])}
        </Styles.InfoText>
      </Styles.ContainerInfo>
      <Styles.ContainerLinkCopy>
        <span>
          {String(event!.attributes.urlRedirectFaceRecognition.value)}
        </span>
        <Styles.CopyLinkBtn
          onClick={handleCopy}
        >
          {copied && <small>{translate(['TICKET_TEMPLATE', 'PASSKEY', 'CLIPBOARD', 'COPY'])}</small>}
          <img
            src={ImagesApp.svg.icCopy}
            alt="cópia"
          />
        </Styles.CopyLinkBtn>
      </Styles.ContainerLinkCopy>
    </Styles.WrapperErrorAlert>
  );
};

export default ErrorAlert;
